import UserMenu from './UserMenu';
import SMenu from '../Menu/';
import Logo from '../tools/Logo';

export const MenuFoldIcon = {
  functional: true,
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  render(h, ctx) {
    const { collapsed } = ctx.props;
    const assign = {
      props: {
        type: collapsed ? 'menu-unfold' : 'menu-fold',
      },
    };
    if (ctx.listeners.toggle) {
      assign.on = { click: ctx.listeners.toggle };
    }
    return <a-icon class="trigger" {...assign} />;
  },
};

const BasicHeaderNavbar = {
  components: { SMenu, UserMenu, Logo },
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    menus: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: 'dark',
    },
    device: {
      type: String,
      required: false,
      default: 'desktop',
    },
    title: {
      type: String,
      default: '',
      required: false,
    },
  },
  methods: {
    /**
     * show when using mobile
     */
    getMenuTrigger() {
      return <MenuFoldIcon collapsed={this.collapsed} on={this.$listeners} />;
    },
    getMeun() {
      return <s-menu mode="horizontal" menu={this.menus} theme={this.theme} />;
    },
  },
  render() {
    const isMobile = this.device === 'mobile';

    return (
      <div class="header-index-left">
        <Logo
          class="top-nav-header"
          show-title={this.showTitle}
          title={this.title}
        />
        { isMobile ? this.getMenuTrigger() : this.getMeun() }
      </div>
    );
  },
};

export default BasicHeaderNavbar;
